"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EcoSabotageRebalanced = void 0;
var GlobalEventName_1 = require("./GlobalEventName");
var PartyName_1 = require("../parties/PartyName");
var Resources_1 = require("../../Resources");
var EcoSabotageRebalanced = (function () {
    function EcoSabotageRebalanced() {
        this.name = GlobalEventName_1.GlobalEventName.ECO_SABOTAGE_REBALANCED;
        this.description = 'Lose 5 plants (reduced by influence).';
        this.revealedDelegate = PartyName_1.PartyName.GREENS;
        this.currentDelegate = PartyName_1.PartyName.REDS;
    }
    EcoSabotageRebalanced.prototype.resolve = function (game, turmoil) {
        var _this = this;
        game.getPlayers().forEach(function (player) {
            var plantPenalty = Math.max(0, 5 - turmoil.getPlayerInfluence(player));
            player.deductResource(Resources_1.Resources.PLANTS, plantPenalty, { log: true, from: _this.name });
        });
    };
    return EcoSabotageRebalanced;
}());
exports.EcoSabotageRebalanced = EcoSabotageRebalanced;
//# sourceMappingURL=EcoSabotageRebalanced.js.map